import { AspectRatio, ChakraProps } from '@chakra-ui/react';
import Modal from '@core/components/Modal/Modal';
import Video from '@core/components/Video/Video';
import { useState } from 'react';

const videoProps = {
  rounded: '1.2rem',
  overflow: 'hidden',
} as const;

export type FullLengthVideoProps = {
  video: string;
  fullVideo: string;
  poster?: string;
  autoplay?: boolean;
} & ChakraProps;

const FullLengthVideo = ({ video, fullVideo, poster, autoplay, ...rest }: FullLengthVideoProps) => {
  const [play, setPlay] = useState(false);

  return (
    <>
      <AspectRatio w="full" ratio={16 / 9}>
        <Video
          video={[{ src: `${video}`, type: 'video/mp4' }]}
          poster={poster}
          autoPlay={autoplay}
          lazy
          loop
          muted
          playsInline
          onClick={() => setPlay(true)}
          cursor="pointer"
          {...videoProps}
          {...rest}
        />
      </AspectRatio>
      <Modal
        size="6xl"
        isOpen={!!play}
        onClose={() => setPlay(false)}
        isCentered
        contentProps={{ py: 0, overflow: 'hidden' }}
        forceCenter
      >
        <Modal.Header position="absolute" zIndex={5} top={0} right={0} />
        <Modal.Body px={0}>
          <AspectRatio w="full" ratio={16 / 9}>
            <Video
              video={[{ src: play ? `${fullVideo}` : '', type: 'video/mp4' }]}
              poster={poster}
              autoPlay={autoplay}
              playsInline
              controls
              border="none"
              rounded={0}
              {...rest}
            />
          </AspectRatio>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FullLengthVideo;
